import type { Match } from "../types";
import { fmtCurrencyBRL } from "../format";
import { Chips } from "./atoms/Chip";

function buildMetaParts(m: Match): string[] {
  const parts: string[] = [];
  if (m.bedrooms != null) parts.push(`${m.bedrooms} qts`);
  if (m.bathrooms != null) parts.push(`${m.bathrooms} ban`);
  if (m.area_m2 != null) parts.push(`${m.area_m2} m²`);
  if (m.neighborhood) parts.push(m.neighborhood);
  return parts;
}

export function MatchCard(
  { m, onFeedback, feedbackDisabled, feedbackPending }: {
    m: Match;
    onFeedback?: (match: Match, feedback: "good" | "bad") => void;
    feedbackDisabled?: boolean;
    feedbackPending?: boolean;
  },
) {
  const price = fmtCurrencyBRL(m.price_brl);
  const meta = buildMetaParts(m);
  const good = m.feedback_good_count ?? 0;
  const bad = m.feedback_bad_count ?? 0;
  const classified = good + bad > 0;
  const disableFeedback = feedbackDisabled || feedbackPending || classified;

  const Thumb = m.image_url
    ? (
      <div
        class="match-thumb"
        style={{ backgroundImage: `url(${m.image_url})` }}
      />
    )
    : <div class="match-thumb">Imóvel</div>;

  return (
    <article class={`match-card ${classified ? "match-card--classified" : ""}`}>
      {Thumb}
      <div class="match-body">
        <div class="match-head">
          <h3 class="match-title">{m.title || "(sem título)"}</h3>
          {m.score != null && (
            <span class="match-score">{(m.score * 100).toFixed(0)}%</span>
          )}
        </div>
        {price && <div class="match-price">{price}</div>}
        {meta.length > 0 && <div class="match-meta">{meta.join(" · ")}</div>}
        {m.highlights && m.highlights.length > 0 && (
          <div><Chips items={m.highlights} /></div>
        )}
        {(good > 0 || bad > 0) && (
          <div class="match-feedback" aria-label="Feedback do match">
            {good > 0 && <span class="match-feedback-good">Bom</span>}
            {bad > 0 && <span class="match-feedback-bad">Ruim</span>}
          </div>
        )}
        <div class="match-actions">
          {m.ego_url && (
            <a
              class="btn"
              href={m.ego_url}
              target="_blank"
              rel="noopener"
            >
              Abrir eGO
            </a>
          )}
          {onFeedback && (
            <div class="match-rating" aria-label="Classificar match">
              <button
                class="match-rating-button match-rating-button--good"
                type="button"
                disabled={disableFeedback}
                onClick={() => onFeedback(m, "good")}
              >
                Bom
              </button>
              <button
                class="match-rating-button match-rating-button--bad"
                type="button"
                disabled={disableFeedback}
                onClick={() => onFeedback(m, "bad")}
              >
                Ruim
              </button>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}
